export default [
	{
		path: "/client/reviews",
		policy: "clientAuth",
		component: "Reviews",
		exact: true,
		mui: true,
	},
];
